import { InvertedRadio, InvertedRadioChecked } from '@components/utility/radios/InvertedRadio';
import { alpha, Chip, ChipProps, Typography } from '@mui/material';
import { ChipPropsColorOverrides } from '@mui/material/Chip/Chip';
import { OverridableStringUnion } from '@mui/types';

interface RadioChipProps
    extends Pick<
        ChipProps,
        'ref' | 'label' | 'classes' | 'color' | 'disabled' | 'skipFocusWhenDisabled' | 'sx' | 'variant' | 'component'
    > {
    /** Whether the radio chip is checked */
    checked?: boolean;
    /** The color palette to use for the checked state of the radio chip */
    paletteColor?: OverridableStringUnion<
        'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning',
        ChipPropsColorOverrides
    >;
    /** Whether the radio chip has a thick border, in the unchecked state */
    thick?: boolean;
}

const RadioChip = ({ checked, paletteColor = 'primary', thick = false, ...props }: RadioChipProps) => (
    <Chip
        color="white"
        {...props}
        label={
            <Typography color={checked ? `${paletteColor}.main` : 'sonic-silver.main'} fontSize={16} fontWeight={600}>
                {props.label}
            </Typography>
        }
        icon={
            checked ? (
                <InvertedRadioChecked color={paletteColor} thick={thick} />
            ) : (
                <InvertedRadio boxShadowColors={['#707579', '#707579']} thick={thick} />
            )
        }
        sx={{
            borderWidth: '1px',
            borderStyle: 'solid',
            borderColor: (theme) => (checked ? theme.palette[paletteColor].main : theme.palette['sonic-silver'].main),
            '&:hover': {
                bgcolor: (theme) => alpha(theme.palette.white.contrastText, 0.05),
            },
        }}
    />
);

export { RadioChip };
